const $ = jQuery.noConflict();

function scrollFunc( e ) {
	const body = $( 'body' );

	const header = document.querySelector( '.main-header' );
	let headerHeight = 0;
	if ( header ) {
		headerHeight = header.getBoundingClientRect().height;
	}
	const alertBar = document.querySelector( '.alert-bar' );
	let alertBarHeight = 0;
	if ( alertBar ) {
		alertBarHeight = alertBar.getBoundingClientRect().height;
	}

	const inpageNav = document.querySelector( '.trex-inpage-nav' );
	let inpageNavHeight = 0;
	if ( inpageNav ) {
		inpageNavHeight = inpageNav.getBoundingClientRect().height;
	}
	let target = false;

	if ( e ) {
		e.preventDefault();
		const trigger = $( e.currentTarget );
		target =
			trigger.attr( 'href' ) === '#next'
				? trigger.parents( 'section' ).next()
				: $( trigger.attr( 'href' ) );
	} else if ( window.location.hash ) {
		const id = window.location.hash;
		if ( id ) {
			target = $( id );
		}
	} else {
		target = $( '.accordion-scroll' );
	}

	if ( target.length ) {
		if ( target.hasClass( 'hook-accordion' ) ) {
			target.addClass( 'active' );
			target.children( '.bellow__content' ).slideDown( 250 );
		}
		const offsetPadding = 50;
		let offset = inpageNav
			? inpageNavHeight + alertBarHeight + headerHeight + offsetPadding
			: headerHeight + alertBarHeight + offsetPadding; // header height
		if ( target.hasClass( 'block-content-form' ) ) {
			offset = headerHeight + alertBarHeight;
		}
		body.addClass( 'smooth-scroll' );
		$( 'html, body' )
			.stop()
			.animate(
				{
					scrollTop: parseInt( target.offset().top - offset, 10 ),
				},
				600,
				() => {
					setTimeout( () => {
						body.removeClass( 'smooth-scroll' );
					}, 100 );
				},
			);
	}
}

/**
 * Prevent automatic scrolling of page to anchor by browser after loading of page.
 * Do not call this function in $(...) or $(window).on('load', ...),
 * it should be called earlier, as soon as possible.
 */
function preventAnchorScroll() {
	if ( window.location.hash ) {
		window.scrollTo( 0, 0 );
	}
	setTimeout( scrollFunc, 100 );
}

function smoothScroll() {
	$( document ).on( 'click', 'a[href^="#"]:not([href="#"])', scrollFunc );
	// setTimeout(scrollFunc, 100);
	preventAnchorScroll();
}

export default smoothScroll;
